import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import userReducer from "./users/usersSlice";
import referralsReducer from "./referrals/referralsSlice";
import rewardsReducer from "./rewards/rewardsSlice";
import adminReducer from "./admin/adminSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    referrals: referralsReducer,
    rewards: rewardsReducer,
    redeems: rewardsReducer,
    admin: adminReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;
